import ApplePayIcon from "@/components/icons/ApplePayIcon.vue";
import GooglePayIcon from "@/components/icons/GooglePayIcon.vue";

export const walletLogo = {
    'apple_pay': ApplePayIcon,
    'google_pay': GooglePayIcon,
};
